// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2NPNN","header":"Messages_header__32avT"};